import { useRouter } from 'next/router';

import { getToolsActiveMenu } from '../../utils/getToolsActiveMenu';

function useToolsSecondaryMenu() {
  const { pathname } = useRouter();

  const activeMenu = getToolsActiveMenu(pathname);

  return {
    activeMenu
  };
}

export default useToolsSecondaryMenu;
